import { createApi } from '@reduxjs/toolkit/query/react';
import ajax from '@/scripts/ajax';

const axiosBaseQuery = () => async (url) => {
    try {
        const result = await ajax.get(url);
        return { data: result };
    } catch (axiosError) {
        let err = axiosError;
        return {
            error: {
                status: err.response?.status,
                data: err.response?.data || err.message,
            },
        };
    }
};

export const apiSlice = createApi({
    baseQuery: axiosBaseQuery(),
    keepUnusedDataFor: 5 * 60,
    endpoints: (builder) => ({
        getStartPort: builder.query({
            query: (location) => `startport?location=${location}`,
        }),
        getEndPort: builder.query({
            query: (location) => `endport?location=${location}`,
        }),
        getArea: builder.query({
            query: () => 'area',
        }),
        getUserPort: builder.query({
            query: () => '/user/get/list',
        }),
    }),
});

export const { useGetStartPortQuery, useGetEndPortQuery, useGetAreaQuery, useGetUserPortQuery } = apiSlice;
